import moment from 'moment'
import Utils from './utils.js'
import CommonOptionsMixin from '@/components/mixins/common-options-mixin'

const LOCAL_STORAGE_MEDIA_ORIENTATION = 'aryaMediaOrientation'
const LANGUAGE_IN_LOCAL_STORAGE = 'aryaLanguage'
const APP_DATA_STORE = 'aryaDataStore'
const APP_DATA_STORE_MODIFIED_FILES = 'aryaDataStoreModifiedFiles'

/**
 * CurrentUser instance dependency
 * @type {any} TODO: type for CurrentUser
 */
let currentUser = null

const dataStoreModel = {
  username: null,
  pageRedirectAfterCreateProject: '/create/template'
}

export default {
  /**
   * Setter for CurrentUser dependency
   *
   * @param {any} currentUserInstance
   */
  setCurrentUserInstance (currentUserInstance) {
    currentUser = currentUserInstance ?? currentUser
  },
  /**
   * Getter for CurrentUser dependency
   * @returns {any} currentUser
   */
  getCurrentUserInstance () {
    if (!currentUser) {
      throw new Error('CurrentUser was not instantiated')
    }

    return currentUser
  },

  default () {
    this.setStore()
  },

  setStore (params) {
    if (typeof (params) === 'undefined' || params === null) params = {}
    const $currentUser = this.getCurrentUserInstance()

    const dataStore = (localStorage.getItem(APP_DATA_STORE) !== null) ? JSON.parse(localStorage.getItem(APP_DATA_STORE)) : []
    const currentUsername = $currentUser.getUsername()
    const findUsernameIndx = dataStore.findIndex((item) => { return item.username && item.username === currentUsername })

    if (findUsernameIndx < 0) {
      let newDataItem = Utils.clone(dataStoreModel)
      newDataItem.username = currentUsername
      newDataItem = { ...newDataItem, ...params }
      dataStore.push(newDataItem)
    } else {
      const currentUserData = dataStore[findUsernameIndx]
      dataStore[findUsernameIndx] = { ...currentUserData, ...params }
    }
    localStorage.setItem(APP_DATA_STORE, JSON.stringify(dataStore))
  },

  getUserName () {
    const $currentUser = this.getCurrentUserInstance()

    if (!$currentUser) {
      return null
    }

    return $currentUser.getUsername()
  },
  getStore () {
    const dataStore = (localStorage.getItem(APP_DATA_STORE) !== null) ? JSON.parse(localStorage.getItem(APP_DATA_STORE)) : []
    const currentUsername = this.getUserName()
    const findUsernameIndx = dataStore.findIndex((item) => { return item.username && item.username === currentUsername })

    return findUsernameIndx >= 0 ? dataStore[findUsernameIndx] : {}
  },
  getSelectedTagsFromLocalStorageSchedulePagePlayers () {
    const selectedTagsFromSlider = this.getStore().selectedTagsFromSlider ? this.getStore().selectedTagsFromSlider : {}
    return selectedTagsFromSlider?.schedulePagePlayers ?? []
  },
  removeStore () {
    localStorage.removeItem(APP_DATA_STORE)
  },
  setMediaOrientation (orientation) {
    if (localStorage.getItem(LOCAL_STORAGE_MEDIA_ORIENTATION) !== null) {
      this.removeMediaOrientation()
    }
    localStorage.setItem(LOCAL_STORAGE_MEDIA_ORIENTATION, orientation)
  },
  getMediaOrientation () {
    const mediaOrientation = localStorage.getItem(LOCAL_STORAGE_MEDIA_ORIENTATION)
    if (mediaOrientation !== null) {
      return mediaOrientation.toLowerCase()
    }
    return 'horizontal'
  },
  removeMediaOrientation () {
    localStorage.removeItem(LOCAL_STORAGE_MEDIA_ORIENTATION)
  },
  setLanguage (code, name, icon, clickedByUser) {
    localStorage.removeItem(LANGUAGE_IN_LOCAL_STORAGE)
    localStorage.setItem(LANGUAGE_IN_LOCAL_STORAGE, JSON.stringify({ code, name, icon, clickedByUser }))
    this.injectLangInHTMLTag(code)
  },
  getLanguage () {
    const langOptions = CommonOptionsMixin.methods.languageCommonOptions()
    const browsersLanguage = window.navigator.userLanguage || window.navigator.language
    let browserLangShort = browsersLanguage
    if (browserLangShort.includes('-')) browserLangShort = browserLangShort.split('-')[0]
    const browserLangExistInList = langOptions.find((langOption) => { return langOption.code === browserLangShort })

    if (localStorage.getItem(LANGUAGE_IN_LOCAL_STORAGE) === null) {
      const setLangParams = { code: 'en', name: 'English', icon: 'uk' }

      if (browsersLanguage !== 'en' && browserLangExistInList) {
        setLangParams.code = browserLangExistInList.code
        setLangParams.name = browserLangExistInList.name
        setLangParams.icon = browserLangExistInList.icon
      }

      this.setLanguage(setLangParams.code, setLangParams.name, setLangParams.icon)
    } else if (localStorage.getItem(LANGUAGE_IN_LOCAL_STORAGE)) {
      const currentLang = JSON.parse(localStorage.getItem(LANGUAGE_IN_LOCAL_STORAGE))

      if (!currentLang.clickedByUser && browserLangExistInList) {
        this.setLanguage(browserLangExistInList.code, browserLangExistInList.name, browserLangExistInList.icon)
      }
    }

    return JSON.parse(localStorage.getItem(LANGUAGE_IN_LOCAL_STORAGE))
  },
  injectLangInHTMLTag (code) {
    $('html').attr('lang', code)
  },
  setModifiedFiles (params) {
    if (!params) params = { resourceId: null }

    if (params) return

    const getDataStore = this.getStore()
    let modifiedFiles = this.getModifiedFiles()

    if (!modifiedFiles) {
      modifiedFiles = this.getModifiedFiles()
    }

    // Set resourceId for template. Format is templateSetId__templateId
    if (!params.resourceId && (params.templateSetId && params.templateId)) {
      params.resourceId = `${params.templateSetId}__${params.templateId}`
      params.type = 'template'
    }

    if (!params.type) params.type = 'media'

    // Add to modified files summary
    if (params.resourceId) {
      const modifiedFile = {
        resourceId: params.resourceId,
        modifiedDate: moment().toISOString(),
        username: getDataStore.username,
        type: params.type
      }
      const modifiedFileInSummary = modifiedFile
      const getFileIndxFromSummary = modifiedFiles.files.findIndex((f) => { return f.resourceId === modifiedFileInSummary.resourceId })

      if (getFileIndxFromSummary >= 0) {
        modifiedFiles.files[getFileIndxFromSummary] = modifiedFileInSummary
      } else {
        modifiedFiles.files.push(modifiedFileInSummary)
      }
    }
  },
  getModifiedFiles () {
    if (localStorage.getItem(APP_DATA_STORE_MODIFIED_FILES) === null) {
      localStorage.setItem(APP_DATA_STORE_MODIFIED_FILES, JSON.stringify({ files: [], users: {} }))
    }

    return JSON.parse(localStorage.getItem(APP_DATA_STORE_MODIFIED_FILES))
  },
  filterModifiedFile (fileSrc) {
    const modifiedFile = {}

    const requiredProperties = ['resourceId', 'modifiedAt', 'templateSetId', 'templateId', 'name', 'userId', 'type']
    requiredProperties.forEach((propName) => {
      if (fileSrc && fileSrc.propName) {
        if (propName === 'userId') {
          modifiedFile.modifiedBy = fileSrc[propName]
        } else {
          modifiedFile[propName] = fileSrc[propName]
        }
      }
    })

    if (modifiedFile.resourceId && modifiedFile.type === 'media') modifiedFile.modifiedId = modifiedFile.resourceId // media file
    if ((modifiedFile.templateSetId && modifiedFile.templateId) && modifiedFile.type === 'template') modifiedFile.modifiedId = `${modifiedFile.templateSetId}_${modifiedFile.templateId}` // template file

    return modifiedFile
  },
  isModifiedFileFlagExpired (fileSrc) {
    const currentDate = moment()
    const currentDateWeek = currentDate.clone().week()
    const fileModifiedDate = fileSrc.modifiedAt ? moment(fileSrc.modifiedAt) : null

    if (!fileModifiedDate) return true
    const fileModifiedWeek = fileModifiedDate.clone().week()

    // Check week difference if modified around 2 weeks ago
    if ((currentDateWeek - fileModifiedWeek) > 1) return true

    return false
  },
  isModifiedFile (params) {
    const modifiedFiles = this.getModifiedFiles() ? this.getModifiedFiles() : false
    if (!modifiedFiles) return false
    if (!params || (params && !params.file)) return false

    let isModifiedFile = false
    const file = this.filterModifiedFile(params.file)
    let updateLocalStorage = false

    const currentModifiedFiles = Utils.clone(modifiedFiles) // Current modified files
    const updatedModifiedFiles = Utils.clone(modifiedFiles) // Modified files to updated
    const currentUserId = this.getStore() && this.getStore().username ? this.getStore().username : null // Current user username

    let isCurrentFileIsMoreRecent = false
    const findFileIndx = currentModifiedFiles.files.findIndex((f) => { return f.modifiedId === file.modifiedId })
    const isFilePresentInLocalStorage = findFileIndx >= 0

    // Modifie file flag part
    if (!isFilePresentInLocalStorage) {
      updatedModifiedFiles.files.push(file)
      isCurrentFileIsMoreRecent = true
      updateLocalStorage = true
    } else {
      isCurrentFileIsMoreRecent = moment(currentModifiedFiles.files[findFileIndx].modifiedAt).isBefore(moment(file.modifiedAt))

      // Update file modifiedAt in localStorage
      if (isCurrentFileIsMoreRecent) {
        updatedModifiedFiles.files[findFileIndx] = file
        updateLocalStorage = true
      }
    }

    // User seen details
    let isCurrentUserSeenTheFile = true
    const userFileFormatIntoLocStorage = {
      modifiedBy: file.modifiedBy,
      modifiedId: file.modifiedId,
      modifiedAt: file.modifiedAt,
      seen: true
    }

    if (!currentModifiedFiles.users[`${currentUserId}`]) {
      if (currentUserId) { // Just to make sure no null userIds
        isCurrentUserSeenTheFile = false
        updatedModifiedFiles.users[currentUserId] = []
        updatedModifiedFiles.users[currentUserId].push(userFileFormatIntoLocStorage)
        updateLocalStorage = true
      }
    } else {
      const userFiles = currentModifiedFiles.users[currentUserId]
      const findFileDetailsIndx = userFiles.findIndex((f) => { return f.modifiedId === file.modifiedId })

      if (findFileDetailsIndx < 0) {
        isCurrentUserSeenTheFile = false

        updatedModifiedFiles.users[currentUserId].push(userFileFormatIntoLocStorage)
        updateLocalStorage = true
      } else {
        const isCurrentFileIsMoreRecentInUsersRecord = moment(userFiles[findFileDetailsIndx].modifiedAt).isBefore(moment(file.modifiedAt))
        if (isCurrentFileIsMoreRecentInUsersRecord) {
          isCurrentUserSeenTheFile = false

          updatedModifiedFiles.users[currentUserId][findFileDetailsIndx] = userFileFormatIntoLocStorage
          updateLocalStorage = true
        } else {
          isCurrentUserSeenTheFile = true
        }
      }
    }

    // Update local storage
    if (updateLocalStorage) localStorage.setItem(APP_DATA_STORE_MODIFIED_FILES, JSON.stringify(updatedModifiedFiles))

    // If not seen by user then marked as modified file
    isModifiedFile = !isCurrentUserSeenTheFile

    // Force to set as NOT modified file if modified by current user
    if (isModifiedFile && file.modifiedBy === currentUserId) isModifiedFile = false

    // Force to set as NOT modified file if modification date is expired for the NEW visibility test
    if (this.isModifiedFileFlagExpired(file)) {
      this.removeModifiedFileLog({ file })
      return false
    }

    return isModifiedFile
  },
  removeModifiedFileLog (params) {
    const modifiedFiles = this.getModifiedFiles() ? this.getModifiedFiles() : false

    if (!params) params = {}
    if (!modifiedFiles) return false

    const file = params.file
    const updatedModifiedFiles = Utils.clone(modifiedFiles) // Modified files to updated
    let updateLocalStorage = false

    // Delete from files
    const findFileIndx = updatedModifiedFiles.files.findIndex((f) => { return f.modifiedId === file.modifiedId })
    if (findFileIndx >= 0) {
      updatedModifiedFiles.files.splice(findFileIndx, 1)
      updateLocalStorage = true
    }

    // Delete in all users
    for (const userId in updatedModifiedFiles.users) {
      const userFiles = updatedModifiedFiles.users[userId]
      const findIndx = userFiles.findIndex((f) => { return f.modifiedId === file.modifiedId })

      if (findIndx >= 0) {
        updatedModifiedFiles.users[userId].splice(findIndx, 1)
        updateLocalStorage = true
      }
    }

    if (updateLocalStorage) localStorage.setItem(APP_DATA_STORE_MODIFIED_FILES, JSON.stringify(updatedModifiedFiles))
  },
  setPreferredTimeFormat (format) {
    localStorage.setItem('TIME_FORMAT', format)
  },
  getPreferredTimeFormat () {
    return localStorage.getItem('TIME_FORMAT')
  }
}
